module.exports = __webpack_public_path__ + "img/pic07.8db6a52e.jpg";